import React, { useState } from "react";
import "../../styles/utils/BookCover.scss";

const BookCover = ({
  title,
  bookcover,
  reading_count,
  onClick,
  index,
  variant,
  className,
  isSelectMode,
  selectedBookId,
  bookId,
  hasAudio,
  onImageLoaded,
}) => {
  let fillColor = "#000000";

  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
    onImageLoaded?.(); // 🔥 부모에 알림
  };
  if (variant === "home") {
    if (index === 0) {
      fillColor = "#FCC92C";
    } else if (index === 1) {
      fillColor = "#4169E1";
    } else if (index === 2) {
      fillColor = "#FF8C00";
    }
  }

  const isSelected = String(selectedBookId) === String(bookId);

  return (
    <li className={`book-cover ${className || ""}`} onClick={onClick}>
      {/* has-audiobook-btn */}
      {hasAudio && (
        <figure className="audiobook-badge">
          <img
            src={"/images/audiobook/has-audio-btn.svg"}
            alt="has-audio-btn"
            loading="lazy"
            decoding="async"
          />
        </figure>
      )}
      {isSelectMode && (
        <div className="book-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      {variant === "home" && (
        <div className="grade-tag">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="41"
            height="52"
            viewBox="0 0 41 52"
            fill="none"
          >
            <path
              d="M0.517578 0.117676H40.1436V51.9889L20.4331 41.8439L0.517578 51.9889V0.117676Z"
              fill={fillColor}
            />
          </svg>
          <span>{index + 1}</span>
        </div>
      )}
      <figure className="book-cover-figure">
        {!isLoaded && (
          <div className="cover-placeholder">
            <div className="spinner"></div>
          </div>
        )}
        <img
          src={bookcover}
          alt={title}
          onLoad={handleImageLoad}
          style={{
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          loading="lazy"
          decoding="async"
        />
      </figure>
      <p className="best-title">{title}</p>
      <div className="book-shadow"></div>
      <div className="book-white"></div>
    </li>
  );
};

export default BookCover;
